import * as $ from 'jquery';
import { LarchSys } from '../../utils/larchSys';


export function projectsBlock(larchSys: LarchSys) {

    $('.module-projectsblock').each(function () {
        var $element = $(this);
        var $column1 = $element.find('.project-list .column:nth-child(1)');
        var $column2 = $element.find('.project-list .column:nth-child(2)');
        var $column3 = $element.find('.project-list .column:nth-child(3)');
        var $teasers: JQuery<HTMLElement> = null;

        function resize() {

            if (window.innerWidth < 992) {
                if ($teasers == null) {
                    $teasers = $column3.find('.project-teaser');
                    $teasers.each((i, teaser) => {
                        const $col = [$column1, $column2][i % 2];
                        $col.append(teaser);
                    });
                }
            } else {
                if ($teasers) {
                    $teasers.each((i, teaser) => {
                        $column3.append(teaser);
                    });
                    $teasers = null;
                }
            }

        }

        $(window).on('resize', resize);
        resize();

    });

}